import dayjs from 'dayjs';
import { DAYJS_FORMATS } from './constants';

export const dateFormat = (data: string) => dayjs(data).format(DAYJS_FORMATS.default);
export const dateAmericanFormat = (date: Date) => dayjs(date).format(DAYJS_FORMATS.american);
export const formatWithoutTime = (data: string) => dayjs(data).format(DAYJS_FORMATS.withoutTime);
export const dateWithLastDayOfMonth = (data: Date) => dayjs(data).utc().endOf('month');

const iso8601Regex = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)((-(\d{2}):(\d{2})|Z)?)$/;
export const isISODate = (date: string) => iso8601Regex.test(date);

/**
 * Converte uma string de data da API para Date ou null
 * Retorna null se a string estiver vazia, for null/undefined ou não for uma data válida
 */
export const convertApiDate = (dateString: string | null | undefined): Date | null => {
  if (!dateString || dateString.trim() === '') {
    return null;
  }
  const date = dayjs(dateString);
  return date.isValid() ? date.toDate() : null;
};

/**
 * Valida se uma data é válida
 * Retorna true se a data não for null, for uma instância de Date e for um timestamp válido
 */
export const isValidDate = (date: Date | null | undefined): date is Date => (
  date !== null && date !== undefined && date instanceof Date && !isNaN(date.getTime())
);

/**
 * Formata uma data para o formato brasileiro (dd/MM/yyyy)
 * Retorna string vazia se a data for inválida
 */
export const formatDateBR = (date: Date | null | undefined): string => {
  if (!isValidDate(date)) {
    return '';
  }
  return date.toLocaleDateString('pt-BR');
};
